// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC<{ width?: number; height?: number; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16">
            <path
                fill="currentColor"
                d="M179.5,3057 C179.775,3057 180,3057.225 180,3057.5 L180,3059 L186,3059 L186,3057.5 C186,3057.225 186.225,3057 186.5,3057 C186.775,3057 187,3057.225 187,3057.5 L187,3059 L188,3059 C189.103125,3059 190,3059.89688 190,3061 L190,3062 L190,3063 L190,3071 C190,3072.10312 189.103125,3073 188,3073 L178,3073 C176.896875,3073 176,3072.10312 176,3071 L176,3063 L176,3062 L176,3061 C176,3059.89688 176.896875,3059 178,3059 L179,3059 L179,3057.5 C179,3057.225 179.225,3057 179.5,3057 Z M189,3063 L177,3063 L177,3071 C177,3071.55313 177.446875,3072 178,3072 L188,3072 C188.553125,3072 189,3071.55313 189,3071 L189,3063 Z M188,3060 L178,3060 C177.446875,3060 177,3060.44687 177,3061 L177,3062 L189,3062 L189,3061 C189,3060.44687 188.553125,3060 188,3060 Z"
                transform="translate(-176 -3057)"
            />
        </svg>
    );
};

export default React.memo(Calendar);
